export const GetUid = () => {
    const uid = document.getElementById("widgetConfig").dataset.uid;
    return uid ?? undefined;
};
